import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { UnKnown, EndOfOrder, Cleaning, Rupture, machineCodes } from '../../../Config/constants'
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { connect } from 'react-redux';

export const BreakDownDetectedDialog = (props) => {

    const classes = useStyles();
    const [message, setMessage] = useState(null)
    const [causeNumber, setCauseNumber] = useState(null)
    const { t } = useTranslation();
    const [stoppedLine, setStoppedLine] = useState(null)
    const [breakdownDetectedDialogOpen, setBreakdownDetectedDialogOpen] = useState(false)
    const appSettings = props.appSettings;

    useEffect(() => {
        const newOpcConnection = new HubConnectionBuilder()
            .withUrl(appSettings.IPB_INTERFACE_OPC_HUB_URL)
            .withAutomaticReconnect()
            .build();

        newOpcConnection.on('ReceiveData', machineData => {
            if (machineData.stopped && machineData.stoppedChanged && machineCodes.find(x => String(x.code) === String(machineData.lineNumber)).id === props.workstation.selectedWorkstation) {

                setBreakdownDetectedDialogOpen(true)
                setStoppedLine(machineData.lineNumber);
            }
            if (machineData.stopReasonKnown) {
                setBreakdownDetectedDialogOpen(false);
            }

            props.machineDataChanged(machineData)

            let machineSpeedArray = []
            let machineRpmPumpArray = []

            machineSpeedArray = JSON.parse(JSON.stringify(props.machineParameter.speed));
            machineRpmPumpArray = JSON.parse(JSON.stringify(props.machineParameter.rpmPump));

            machineSpeedArray.find(x => parseInt(x.lineNumber) === parseInt(machineData.lineNumber)).speed = machineData.speed;
            machineRpmPumpArray.find(x => x.lineNumber === machineData.lineNumber).rpmPump = machineData.rpmPump;

            props.actions.setSpeed(machineSpeedArray);
            props.actions.setRpmPump(machineRpmPumpArray);
        });
        newOpcConnection.start().then(() => {
            console.log('OPC connected!');
        }).catch(e => console.log('OPC connection failed: ', e));
        // eslint-disable-next-line
    }, [props.workstation.selectedWorkstation]);

    function changeCauseNumber(number) {
        if (number === causeNumber) {
            setCauseNumber(null)
        }
        else {
            setCauseNumber(number)
        }
        if (causeNumber !== UnKnown) {
            setMessage(null)
        }
    }

    const sendBreakdownReason = () => {

        let reasonDescription = null
        if (causeNumber === UnKnown) {
            reasonDescription = message
        }

        dataService.machineStoppedReasonNodeRED(stoppedLine, causeNumber, reasonDescription, props.user.userInfo.given_name).then().catch((error) => { toast.error(error, { position: "top-center" }) })

        setCauseNumber(null)
        setMessage(null)
        setBreakdownDetectedDialogOpen(false)
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={breakdownDetectedDialogOpen}
            aria-labelledby="draggable-dialog-title"

        >
            <div className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
                {t("Breakdown detected on line ") + stoppedLine}
            </div>
            <div className={classes.dialogContext}>
                {t("What is the cause of the breakdown?")}
            </div>
            <div className={classes.breakdowncauses}>
                <div className={classes.cause}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={causeNumber === EndOfOrder}
                        onChange={() => changeCauseNumber(EndOfOrder)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    />
                    <div className={classes.causeName}>{t("End of order")}</div>
                </div>
                <div className={classes.cause}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        onChange={() => changeCauseNumber(Cleaning)}
                        checked={causeNumber === Cleaning}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    />
                    <div className={classes.causeName}>{t("Cleaning")}</div>
                </div>
                <div className={classes.cause}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        onChange={() => changeCauseNumber(Rupture)}
                        checked={causeNumber === Rupture}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    />
                    <div className={classes.causeName}>{t("Rupture")}</div>
                </div>
                <div className={classes.cause}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={causeNumber === UnKnown}
                        onChange={() => changeCauseNumber(UnKnown)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    />
                    <div className={classes.causeName}>{t("Else")}</div>
                </div>
            </div>
            {causeNumber === UnKnown ? <TextField id="outlined-search" label="" type="text" multiline rows={3} variant="outlined" value={causeNumber === UnKnown ? message : ""} className={classes.uiTextField} onChange={(e) => setMessage(e.target.value)} /> : <React.Fragment></React.Fragment>}
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.submitButton} disabled={causeNumber === null || (causeNumber === UnKnown && (message === null || message === ""))} autoFocus={false} onClick={() => sendBreakdownReason()} >
                        {t("SUBMIT")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        height: "auto !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    submitButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "160px",
        marginBottom: "30px",
        marginTop: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        fontSize: "32px !important",
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "50px",
        marginBottom: "5px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingLeft: "50px",
        paddingRight: "50px",
        height: "20px",
        marginBottom: "15px"
    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        float: "left"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },
    causeName: {
        float: "left",
        paddingTop: "8px",
        marginLeft: "5px",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
    },
    breakdowncauses: {
        width: "330px",
        height: "100px",
        marginRight: "auto",
        marginLeft: "auto",
        paddingLeft: "30px"
    },
    cause: {
        width: "50%",
        height: "50px",
        float: "left"
    },
    uiTextField: {
        width: "300px",
        backgroundColor: "white",
        marginRight: "auto",
        marginLeft: "auto"
    },
    textField: {
        width: "300px",
        marginRight: "auto",
        marginLeft: "auto"
    }
}));


// function mapStateToProps(state) {
//     console.log("mapStateToProps of Breakdown dialog");
//     console.log(state);
//     return {
//         machineParameter: state.machineParameter,
//     }
// }

const mapStateToProps = state => ({
    machineParameter: state.machineParameter,
    workstation: state.workstation
})

export default connect(mapStateToProps)(BreakDownDetectedDialog)